import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";
import LeaveTimeline from './LeaveTimeline';

    const PersonalLeavePlans = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [isLoading, setIsLoading] = useState(false)
        const [deptList, setDeptList] = useState([])

        const [sStartDate, setSStartDate] = useState([new Date(new Date().getFullYear(), 0, 1)]);
        const [sEndDate, setSEndDate] = useState([new Date(new Date().getFullYear(), 11, 31)]);
        const [sEmployeeNo, setSEmployeeNo] = useState('') 
        const [sEmployeeName, setSEmployeeName] = useState('')  
        const [sDocumentNo, setSDocumentNo] = useState('')
        const [sDeptId, setSDeptId] = useState('')
        const [sLocationId, setSLocationId] = useState('')
        const [sStatus, setSStatus] = useState('')
        
        const [leavePlans, setLeavePlans] = useState([])
        const [documentNo, setDocumentNo] = useState('')
        const [leaveType, setLeaveType] = useState('')
        const [startDate, setStartDate] = useState([new Date()])
        const [endDate, setEndDate] = useState([new Date()])
        const [remark, setRemark] = useState('')
        const [status, setStatus] = useState('Open')
        const [userId, setUserId] = useState('')

        const [employeeId, setEmployeeId] = useState('')
        const [employeeNo, setEmployeeNo] = useState('')
        const [employeeName, setEmployeeName] = useState('')
        const [employeeTitle, setEmployeeTitle] = useState('')
        const [employeeDept, setEmployeeDept] = useState('')

        const [isEdit, setIsEdit] = useState(false)
        const [planId, setPlanId] = useState('')
        const [department, setDepartment] = useState('')
        const [location, setLocation] = useState('')

        const [leavePlanTypeOptions, setLeaveTypePlanOptions]     = useState(['Annual Leave', 'Study Leave'])
        const [jobLocationOptions, setJobLocationOptions]     = useState([])
        const [leaveStatusOptions, setEmployeeStatusOptions]     = useState(['Open', 'Pending Approval', 'Approved'])
        const [modal_plan, setmodal_plan] = useState(false);

        const [selectedEmployee, setSelectedEmployee] = useState('')
        const [st, setSt] = useState(0)
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_plan = () => {
          setmodal_plan(!modal_plan);
          removeBodyCss();
        }
        const fetchData = () => {
          axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data) }).catch((e)=>console.log(e))
          axios.get(url.HRLOCATIONS, Config).then((r)=>{ setJobLocationOptions(r.data);  }).catch((e)=>{  console.log(e); });
          handleFilterData()
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
            setEmployeeId(obj.hrId)
            setEmployeeNo(obj.hrNo)
            setEmployeeName(obj.hrName)
            setEmployeeTitle(obj.hrTitle)
            setEmployeeDept(obj.hrDept)
            const data = {
                id          : '',
                startDate   : formatDate(sStartDate),
                endDate     : formatDate(sEndDate),
                employeeNo  : obj.hrNo,
                employeeName: '',
                documentNo  : '',
                deptId      : '',
                locationId  : '',
                status      : ''
             }
             setIsLoading(true)
             axios.post(url.HRLEAVEPLANFILTER, JSON.stringify(data), Config).then((r)=>{
                  setLeavePlans(r.data)
              }).catch((e)=>{
                  console.log(e)
              }).finally(()=>{
                  setIsLoading(false)
              })
          } 
        },[]);

        
        
        const handleFilterData = () =>{
          const data = {
            id          : '',
            startDate   : formatDate(sStartDate),
            endDate     : formatDate(sEndDate),
            employeeNo  : employeeNo,
            employeeName: '',
            documentNo  : sDocumentNo,
            deptId      : '',
            locationId  : '',
            status      : sStatus
         }
         setIsLoading(true)
         axios.post(url.HRLEAVEPLANFILTER, JSON.stringify(data), Config).then((r)=>{
              setLeavePlans(r.data)
          }).catch((e)=>{
              console.log(e)
          }).finally(()=>{
              setIsLoading(false)
          })
        }
        const handleClearSearch = () =>{
          setPlanId('')
          setSStartDate([new Date()])
          setSEndDate([new Date()])
          setSEmployeeName('')
          setSEmployeeNo('')
          setSDocumentNo('')
          setSDeptId('')
          setSLocationId('')
          setSStatus('')
          handleFilterData()
        }

        const handleClickAdd = () =>{
          setIsEdit(false)
          setSelectedEmployee(null)
          setDocumentNo('')
          setStartDate([])
          setEndDate([])
          setLeaveType('')
          setRemark('')
          setPlanId('')
          setStatus('Open')
          tog_plan()
        }
        const handleSavePlan = () =>{
          const data = {
            id        : isEdit?planId:'',
            empId     : employeeId,
            documentNo: documentNo,
            leaveType : leaveType,
            startDate : formatDate(startDate),
            endDate   : formatDate(endDate),
            remarks   : remark,
            status    : status,
            addedBy   : userId,
            action    : isEdit?"edit":"add"
          }
          setIsLoading(true)
          axios.post(url.HRLEAVEPLAN, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == "1"){
              toastr.success(r.data.message)
              tog_plan()
              setDocumentNo('')
              setStartDate([])
              setEndDate([])
              setLeaveType('')
              setRemark('')
              setPlanId('')
              fetchData()
            }else{
              toastr.error(r.data.message)
            }
          }).catch((e)=>{
            console.log(e)
          }).finally(()=>{
            setIsLoading(false)
          })
        }

        const handleSendForApproval = () =>{
            setIsLoading(true)
            const data = {
                action  : 'request',
                entity  : 'Leave Plan', 
                no      : documentNo,
                id      : planId, 
                userId  : userId
            }
            axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    tog_plan()
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
    
        }
        const handleCancelApproval = () =>{
            const data = {
                action  : 'cancel', 
                entity  : 'Leave Plan', 
                no      : documentNo,
                id      : planId, 
                userId  : userId
            }
           
            setIsLoading(true)
            axios.post(url.SENDAPPROVALREQUEST, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == 1){
                    toastr.success(r.data.message)
                    tog_plan()
                    fetchData()
                }else{
                    toastr.error(r.data.message)
                }
            }).catch((e)=>{
                console.log(e)
            }).finally(()=>{
                setIsLoading(false)
            })
        }
        const handleDeletePlan = () =>{
            const data = {
                id        : planId,
                empId     : employeeId,
                documentNo: documentNo,
                leaveType : leaveType,
                startDate : formatDate(startDate),
                endDate   : formatDate(endDate),
                remarks   : remark,
                status    : status,
                addedBy   : userId,
                action    : "delete"
              }
              setIsLoading(true)
              axios.post(url.HRLEAVEPLAN, JSON.stringify(data), Config).then((r)=>{
                if(r.data.status == "1"){
                  toastr.success(r.data.message)
                  tog_plan()
                  setDocumentNo('')
                  setStartDate([])
                  setEndDate([])
                  setLeaveType('')
                  setRemark('')
                  setPlanId('')
                  fetchData()
                }else{
                  toastr.error(r.data.message)
                }
              }).catch((e)=>{
                console.log(e)
              }).finally(()=>{
                setIsLoading(false)
              })
        }
        const pageOptions = {
          sizePerPage: 10000,
          totalSize: leavePlans.length,
          custom: true,
        }
        var node = useRef();
              
        const columns = [
        {
          dataField: 'document_no',
          text: 'No',
          sort: true
        },
        {
          dataField: 'first_name',
          text: 'Employee',
          sort: true,
          formatter: nameFormatter
        },
        {
          dataField: 'department',
          text: 'Department',
          sort: true
        },
        {
          dataField: 'location',
          text: 'Location',
          sort: true
        }, 

        {
          dataField: 'leave_type',
          text: 'Leave Type',
          sort: true
        }, 
        {
          dataField: 'start_date',
          text: 'Start',
          sort: true
        }, 
        {
          dataField: 'end_date',
          text: 'End',
          sort: true
        }, 
        {
          dataField: 'leave_status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];
        function nameFormatter(cellContent, row){
          return(
            <div>{row.first_name}{" "}{row.surname}</div>
          )
        }
 
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ 
                        tog_plan(); 
                        setIsEdit(true); 
                        setPlanId(row.pid); 
                        setLeaveType(row.leave_type)
                        setStartDate([new Date(row.start_date)])
                        setEndDate([new Date(row.end_date)])
                        setRemark(row.remarks)
                        setDepartment(row.department)
                        setLocation(row.location)
                        setDocumentNo(row.document_no)
                        setStatus(row.leave_status)
                        if(row.leave_status == 'Open'){
                            setSt(0)
                        } else if (row.leave_status == 'Pending Approval'){
                            setSt(1)
                        }else{
                            setSt(2)
                        }
                    }
                  }
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if (cellContent == "Closed") {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else if(cellContent == "Pending Approval"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-dark">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Leave Planning | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_plan} toggle={() => { tog_plan(); }}  size="xl" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`} Leave Plan</h5>
                                    <button type="button"  onClick={() => { setmodal_plan(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                <Row>
                                    <Col md={8}>
                                    <Row>
                                      {isEdit && (
                                      <Col md={12}>
                                        <div className="mb-3">
                                            <label>Document No</label>
                                            <input className='form-control' type='text' defaultValue={documentNo} disabled={true}/>
                                        </div>
                                      </Col>
                                      )}
                                      <Col md={6}>
                                          <div className="mb-3">
                                              <label>Employee No</label>
                                              <input className='form-control' type='text' defaultValue={employeeNo} disabled={true}/>
                                          </div>
                                      </Col>
                                      <Col md={6}>
                                          <div className="mb-3">
                                              <label>Employee Name</label>
                                              <input className='form-control' type='text' defaultValue={employeeName} disabled={true}/>
                                          </div>
                                      </Col>
                                      <Col md={6}>
                                          <div className="mb-3">
                                              <label>Employee Title</label>
                                              <input className='form-control' type='text' defaultValue={employeeTitle} disabled={true}/>
                                          </div>
                                      </Col>
                                      <Col md={6}>
                                          <div className="mb-3">
                                              <label>Department</label>
                                              <input className='form-control' type='text' defaultValue={employeeDept} disabled={true}/>
                                          </div>
                                      </Col>
                                 
                                        <Col md={6}>
                                        <div className="mb-3">
                                            <label>Location</label>
                                            <input className='form-control' type='text' defaultValue={location} disabled={true}/>
                                        </div>
                                        </Col>
                                     
                                      <Col md={6}>
                                          <div className="mb-3">
                                              <label>Leave Type</label>
                                              <select className="form-select" value={leaveType} onChange={(e)=>setLeaveType(e.target.value)}>
                                              <option value=""></option>
                                                  {(leavePlanTypeOptions || []).map((d,k)=>(
                                                  <option key={k} value={d}>{d}</option>
                                                  ))}
                                              </select>
                                          </div>
                                      </Col>
                                      <Col xl={6}>
                                          <div className="mb-3">
                                              <label>Start Date</label>
                                              <Flatpickr
                                                  className="form-control"
                                                  options={{
                                                      dateFormat: "Y-m-d",
                                                      enableTime: false
                                                  }}
                                                  value={startDate}
                                                  onChange={(dates)=>{setStartDate(dates); }}
                                                  />
                                          </div>
                                      </Col>
                                      <Col xl={6}>
                                        <div className="mb-3">
                                            <label>End Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={endDate}
                                                onChange={(dates)=>{setEndDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Remark</label>
                                            <textarea className="form-control form-control" value={remark} onChange={(e)=>setRemark(e.target.value)} />
                                            
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select" value={status} disabled={true} onChange={(e)=>setStatus(e.target.value)} >
                                              <option value=""></option>
                                              <option value="Open">Open</option>
                                              <option value="Pending Approval">Pending Approval</option>
                                              <option value="Closed">Closed</option>
                                            </select>
                                            
                                        </div>
                                    </Col>
                                    </Row>

                                    </Col>
                                    <Col md={4}>
                                        <LeaveTimeline stage={st}/>
                                    </Col>
                                </Row>
                                    
                                </div>
                                <div className="modal-footer">
                                {isLoading ? (<div>Please wait...</div>) : (
                                <>
                                {(isEdit == false) && (<button type="button" className="btn btn-success" onClick={handleSavePlan} >Save...</button>)}
                                {(isEdit && (status == 'Open')) && (<><button type="button" className="btn btn-success" onClick={handleSavePlan} >Update Plan...</button>
                                                                        <button type="button" className="btn btn-warning" onClick={handleSendForApproval} >Send Plan for Approval</button>
                                                                        <button type="button" className="btn btn-danger" onClick={handleDeletePlan} >Delete Leave Plan</button></>)}
                                {(isEdit && (status == 'Pending Approval')) && (<><button type="button" className="btn btn-warning" onClick={handleCancelApproval} >Cancel Approval request</button>
                                    </>)}
                                </>)}
                                </div>
                                </Modal> 
                     
                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                                <Row className="justify-content-center mb-1">
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>Start Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                    dateFormat: "Y-m-d",
                                                                    enableTime: false
                                                                }}
                                                                value={sStartDate}
                                                                onChange={(dates)=>{setSStartDate(dates); }}
                                                                />
                                                        </div>
                                                    </Col>
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>End Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                    dateFormat: "Y-m-d",
                                                                    enableTime: false
                                                                }}
                                                                value={sEndDate}
                                                                onChange={(dates)=>{setSEndDate(dates); }}
                                                                />
                                                        </div>
                                                    </Col>
                                          
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Document No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sDocumentNo} onChange={(e)=>setSDocumentNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(leaveStatusOptions || []).map((e,k)=>(
                                                                <option value={e} key={k}>{e}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                          
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                        
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add Leave Plan
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">MY Leave Plans ({leavePlans.length})</h5>
                                                  <CardBody>

                                                                                             
                                {(leavePlans.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="pid"
                                    columns={columns}
                                    data={leavePlans}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="pid"
                                      data={ leavePlans }
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='pid' 
                                                  data={ leavePlans } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((leavePlans || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No Plan Created</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={()=>{handleClickAdd()}}
                                       
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Create Leave Plan <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>   
                        </Row>
                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PersonalLeavePlans;